// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "../../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function getVm(order) {
  var order$1 = order._0;
  return {
          pickup_landmark: order$1.pickup_info.place.landmark,
          from_state: order$1.from_state,
          contact: order$1.pickup_info.contact.number,
          to_state: order$1.to_state,
          drop_landmark: Belt_Option.mapWithDefault(order$1.drop_info, "N/A", (function (loc) {
                  return loc.place.landmark;
                }))
        };
}

export {
  getVm ,
  
}
/* No side effect */
